<ng-container *transloco="let t">
    <div class="offcanvas-header">
        <h4 class="offcanvas-title">{{title}}</h4>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" (click)="cancel()"></button>
    </div>
    <div class="offcanvas-body">
        <div class="p-4">
            {{text}}
        </div>
    </div>
    <div class="offcanvas-footer">
        <div class="d-flex justify-content-between">
            <div class="col-6 px-2">
                <app-rounded-button [label]="t('app.common.cancel')" [fullWidth]="true"
                                    [btnClass]="'rounded-button--black-outline'" (onClick)="cancel()"/>
            </div>
            <div class="col-6 px-2">
                <app-rounded-button [label]="t('app.common.confirm')" (onClick)="confirm()" [fullWidth]="true"
                                    [btnClass]="'rounded-button--solid'"></app-rounded-button>
            </div>
        </div>
    </div>
</ng-container>